import React from "react";
import ProductGallery from "../../GalleryImagesComponent";
import Image1 from "../../../../Product/Sportswear/Outfit-Sport/Ot1.webp";
import Image2 from "../../../../Product/Sportswear/Outfit-Sport/Ot2.webp";
import Image3 from "../../../../Product/Sportswear/Outfit-Sport/Ot3.webp";
import Image4 from "../../../../Product/Sportswear/Outfit-Sport/Ot4.webp";
import Image5 from "../../../../Product/Sportswear/Outfit-Sport/Ot5.webp";
import Image6 from "../../../../Product/Sportswear/Outfit-Sport/Ot6.webp";

const OutfitSport = () => {
  const images = [Image1, Image2, Image3, Image4, Image5, Image6];

  return (
    <ProductGallery
      images={images}
      category={{ english: "sports", enName: "Sports wear", arabic: "الرياضية", arName: "الرياضية" }}
      product={{ english: "Outfit", arabic: "ملابس رياضية كاملة" }}
    />
  );
};

export default OutfitSport;
